import { render } from "./PageLinkListBlock.vue?vue&type=template&id=295e50c6"
import script from "./PageLinkListBlock.vue?vue&type=script&lang=js"
export * from "./PageLinkListBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__